export default "__VITE_ASSET__CSvDiE$___"